/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PROAUTH", "542")
  

// 接口文档



export interface API75734Req {
  
  /**  */
  dataId: string;
  /**  */
  version: number;
};



export type API75734Res = {};


// 接口函数 75734 发布模型

export interface IUsePostAPI75734Return {
  /** 发布模型: 接口请求状态 */
  isAPI75734Loading: boolean;
  /** 发布模型: 接口请求返回数据 */
  dataAPI75734: API75734Res;
  /**  发布模型: 接口数据请求方法 */
  fetchAPI75734Data: (inputs: API75734Req, config?: YWRequestConfig) => Promise<API75734Res>;
  /** 发布模型: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75734 = ():IUsePostAPI75734Return => {
  let isMount = true;
  const [isAPI75734Loading, setIsAPI75734Loading] = useState(false);
  const [dataAPI75734, setDataAPI75734] = useState<API75734Res>({} as API75734Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/publish`;

  const fetchAPI75734Data = async (inputs: API75734Req, config?: YWRequestConfig): Promise<API75734Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75734Req>) || {}) as API75734Req;
    
  
    if ( isMount ) {
      setIsAPI75734Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75734Res>(`${basePath}/yoaichat-web/chat/task/model/publish`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75734(res || {} as API75734Res);
        setIsAPI75734Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75734Loading(false);
      }
      return false as unknown as API75734Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75734Loading,
    dataAPI75734,
    fetchAPI75734Data,
    requestUrl,
  }
}

